import styled from 'styled-components';
import {Button} from '@guestapp/ui';
import {device} from 'styled/device';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const WelcomeText = styled.div`
  display: none;

  @media (min-width: ${device.tablet}) {
    display: block;
    margin: 24px auto;
    font-weight: 500;
    font-size: 28px;
    line-height: 24px;
    letter-spacing: 0.36px;
    color: #152946;
  }
`;

export const LetsChekinText = styled.div`
  display: none;

  @media (min-width: ${device.tablet}) {
    display: block;
    margin: 0 auto 64px;
    font-weight: 600;
    font-size: 38px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.36px;
    color: #393abd;
  }
`;

export const BottomPictureBg = styled.img`
  width: 290px;
  position: fixed;
  bottom: 0;
  left: 0;
  display: none;
  z-index: 0;

  @media (min-width: ${device.tablet}) {
    display: block;
  }
  @media (min-width: ${device.laptop}) {
    width: 290px;
  }
`;

export const LeftArrowBg = styled.img`
  width: 74px;
  position: fixed;
  left: 11%;
  top: 50%;
  transform: translateY(-50%) rotate(31deg);
  display: none;
  z-index: 0;
  @media (min-width: ${device.laptop}) {
    display: block;
  }
`;

export const RightArrowBg = styled.img`
  width: 176px;
  position: fixed;
  right: 9%;
  top: 58%;
  display: none;
  z-index: 0;

  @media (min-width: ${device.laptop}) {
    display: block;
  }
`;

export const RightMessageIconBg = styled.img`
  width: 34px;
  position: fixed;
  right: 18%;
  top: 40%;
  display: none;
  z-index: 0;
  @media (min-width: ${device.laptop}) {
    display: block;
  }
`;

export const WorldMapBg = styled.img`
  position: fixed;
  left: 0;
  bottom: 0;
  display: none;
  z-index: 0;
  @media (min-width: ${device.tablet}) {
    display: block;
    width: 94%;
    top: 50%;
    transform: translate(-50%, -50%);
    left: 50%;
  }

  @media (min-width: ${device.laptop}) {
    width: 70%;
  }
`;

export const PoweredByChekin = styled.img`
  position: fixed;
  z-index: 0;
  right: 26px;
  bottom: 17px;
`;
export const CustomBackButton = styled(Button)`
  display: none;
  position: absolute;
  font-size: 14px;
  font-weight: 700;

  & .button__left-icon {
    padding-right: 10px;
  }

  @media (min-width: ${device.tablet}) {
    /* width: 70px; */
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    position: absolute;
    left: 5%;
  }
`;
